<h1 mat-dialog-title>Selecciona para que numero de parte se utilizara</h1>
<mat-dialog-content>
  <form [formGroup]="form">
    <mat-form-field class="tw-flex tw-w-full" appearance="outline">
      <mat-label>Numero de parte</mat-label>
      <mat-select formControlName="partNumber">
        <mat-option>
          <ngx-mat-select-search
            placeholderLabel="Buscar..."
            formControlName="search"
            noEntriesFoundLabel="Sin resultados"
          >
          </ngx-mat-select-search>
        </mat-option>
        <mat-option value="undefined"> N/A </mat-option>
        <mat-option *ngFor="let op of filteredPartNumbers" [value]="op">{{
          op
        }}</mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button mat-dialog-close class="app-btn-close">
    Cerrar
  </button>
  <button
    mat-raised-button
    mat-dialog-close
    class="app-btn-save"
    [disabled]="form.invalid"
    (click)="finish()"
  >
    Imprimir etiqueta
  </button>
</mat-dialog-actions>
